import React, { FC, useEffect } from 'react';
import { PageProps } from 'gatsby';
import { Button, Seo } from '../../components';
import { PageLayout } from '../../components';
import config from '../../../app-config.json';
import { siteMetadata } from '../../../gatsby-config';
import * as s from '../../style.pages/index.style';
import { BodyWrap } from '../taher-scheme';
import { Grid, Typography, useMediaQuery } from '@material-ui/core';
import { RouteComponentProps } from '@reach/router';
import { logoutFromQardanPortal } from '../../reduxStore/slices/qardanPortalSlice';
import { useAppDispatch, useAppSelector } from '../../reduxStore/store';
import Form, { CombineFieldInterface } from '../../components/Form/FormLib';
import { navigate } from 'gatsby-link';
import { endpoints } from '../../../app-config.json';
import { AccountApp } from '../../components/qardan-hasana';
import { MetaDescription } from '../husain-scheme';
import axios from 'axios';
import { ErrorDialog, SuccessDialog } from '../../components/Alert';

const PARENT_PAGE_TITLE = config.pages.QARDAN_HASANA.title;
const PAGE_TITLE = config.pages.QARDAN_HASANA.routes['upload-extra-docs'].title;

//////////////////////////////////  component ////////////////////////////////
const Page: FC<RouteComponentProps> = () => {

    const handleSubmit = async (values: any) => {
        console.log(values);
        const { applicantId, fileName, file } = values;
        try {
            const { data: { keys, presignedPutUrls, driveFolder } } = await axios.post(endpoints['get-s3-signed-url-for-qh-applicant-id'], {
                files_name: [fileName],
                qh_applicant_id: applicantId
            });

            await Promise.all(presignedPutUrls.map(url => (
                axios.put(url, file[0], {
                    headers: {
                        "Content-Type": file[0].type,
                    }
                })
            )))

            const { data } = await axios.post(endpoints['upload-qardan-additional-documents'], {
                keys,
                driveFolderId: driveFolder.id
            });

            await SuccessDialog("Success", "File uploaded successfully.");


        } catch (error: any) {
            ErrorDialog('File Upload Error', error.response.data.message || "Something went wrong while uploading the file.");
        }

    }

    return (
        <PageLayout>
            <Seo title={`${PAGE_TITLE} | ${PARENT_PAGE_TITLE} | ${siteMetadata.title}`} />
            <s.BodyWrap >
                <br />
                <Typography variant='h2' >{PAGE_TITLE.replace('(London)', "")}</Typography>
                <hr /><br /> <br />

                <Form
                    onSubmit={handleSubmit}
                    fields={[
                        { type: "text", name: "applicantId", label: "Applicant ID", fieldArea: { xs: 12 } },
                        { type: "text", name: "fileName", label: "File Name", fieldArea: { xs: 12, sm: 6, } },
                        { type: "file", name: "file", label: "Qardan Hasana File", accept: ["pdf", "png", "JPEG", "jpg"], fieldArea: { xs: 12, sm: 6, } },
                        { type: 'submit', name: "submit-btn", label: "Upload", }
                    ]}

                />

            </s.BodyWrap>
        </PageLayout>
    )
}

export default Page;

